/*@ngInject*/
const DataSetSettingsController = function ($scope, $state, $rootScope, $stateParams, $q, $uibModal, $uibModalInstance, authorizationConstants, dataSetEditorModel, configurationMediator, currentUserModel, coreConstant, dataSetType, loadingBarHandler, localization, navigationStateModel, modalOptions) {

    let translations;

    $scope.viewModel = {
        dataSetDefinition: {},
        originalDataSetDefinition: {},
        title: '',
        confirmButtonLabel: '',
        dataSetTypes: dataSetType,
        canManageDataSets: false,
        repeatingFormTemplateUniqueNameList: null,
        generatorDefinitionList: null,
        selectedGeneratorDefinition: null,
        generatorBeanNamePlaceHolder: '',
        repeatingFormTemplateUniqueNamePlaceHolder: '',
        defaultMinSearchStringLength: 3,
        isSubmitDisabled: false
    };

    $scope.viewModel.canManageDataSets = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);

    localization.getTranslationsByKeys(['dataSetSettings']).then(function (result) {
        translations = result;
        $scope.viewModel.title = _.isNil(modalOptions.existingDataSetName) ? translations.newDataSetTitle : translations.title;
        $scope.viewModel.confirmButtonLabel = _.isNil(modalOptions.existingDataSetName) ? translations.createDataSet : translations.saveButton;
        $scope.viewModel.generatorBeanNamePlaceHolder = translations.generatorBeanNamePlaceHolder;
        $scope.viewModel.repeatingFormTemplateUniqueNamePlaceHolder = translations.repeatingFormTemplateUniqueNamePlaceHolder;
    });

    function init() {
        if (!_.isNil(modalOptions.dataSet)) {
            $scope.viewModel.dataSetDefinition = modalOptions.dataSet;
            // set initial values on properties that are undefined to allow for proper equality comparison to determine if save button is enabled
            if (_.isNil($scope.viewModel.dataSetDefinition.description)) {
                // set to an empty string since input of a description will set to an empty string upon clearing an input
                // i.e. user starts to put in a description, but then decides to clear the input; then the description should be equivalent to when it started as "empty"
                $scope.viewModel.dataSetDefinition.description = '';
            }
            if (_.isUndefined($scope.viewModel.dataSetDefinition.dynamicDefault)) {
                $scope.viewModel.dataSetDefinition.dynamicDefault = null;
            }
            if (_.isUndefined($scope.viewModel.dataSetDefinition.generatorBeanName)) {
                $scope.viewModel.dataSetDefinition.generatorBeanName = null;
            }
            if (_.isUndefined($scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName)) {
                $scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName = null;
            }
            if (_.isUndefined($scope.viewModel.dataSetDefinition.supportSearch)) {
                $scope.viewModel.dataSetDefinition.supportSearch = false;
            }
            if (_.isUndefined($scope.viewModel.dataSetDefinition.clearInvalidFieldValue)) {
                $scope.viewModel.dataSetDefinition.clearInvalidFieldValue = true;
            }
            $scope.viewModel.originalDataSetDefinition = _.cloneDeep($scope.viewModel.dataSetDefinition);
            loadData().then(function () {
                $scope.viewModel.selectedGeneratorDefinition = _.find($scope.viewModel.generatorDefinitionList, function (generatorDefinition) {
                    return generatorDefinition.beanName === modalOptions.dataSet.generatorBeanName;
                });
            });
        } else {
            $scope.viewModel.dataSetDefinition.type = dataSetType.STATIC;
            $scope.viewModel.dataSetDefinition.dynamicDefault = false;
            $scope.viewModel.dataSetDefinition.supportSearch = false;
            $scope.viewModel.dataSetDefinition.minSearchStringLength = $scope.viewModel.defaultMinSearchStringLength;
            $scope.viewModel.dataSetDefinition.clearInvalidFieldValue = true;
        }
    }

    function loadData() {
        let promiseList = [];

        if ($scope.viewModel.dataSetDefinition.type === dataSetType.CUSTOM ||
            $scope.viewModel.dataSetDefinition.type === dataSetType.REPEATING_FORM ||
            $scope.viewModel.dataSetDefinition.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
            promiseList.push(
                configurationMediator.getGeneratorDefinitions($scope.viewModel.dataSetDefinition.type).then(function (result) {
                    $scope.viewModel.generatorDefinitionList = result;
                })
            );
        }

        if ($scope.viewModel.dataSetDefinition.type === dataSetType.REPEATING_FORM) {
            promiseList.push(
                configurationMediator.getRepeatingFormTemplateUniqueNames().then(function (result) {
                    $scope.viewModel.repeatingFormTemplateUniqueNameList = result;
                })
            );
        }

        return $q.all(promiseList);
    }

    function saveSuccess(dataSet) {
        const navigationModel = {
            parentState: 'configuration.dataSetBrowser',
            currentState: 'configuration.dataSetEditor.dataItems',
            data: {
                dataSetName: dataSet.name,
                type: dataSet.type
            }
        };

        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSucceeded'));
        dataSetEditorModel.updateDataSet(dataSet);

        if (dataSet.type === dataSetType.REPEATING_FORM) {
            $state.go('configuration.dataSetEditor.repeatingForm', {
                dataSetName: dataSet.name,
                type: dataSet.type
            });
        } else {
            $state.go('configuration.dataSetEditor.dataItems', {
                dataSetName: dataSet.name,
                type: dataSet.type
            });
        }

        navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        $uibModalInstance.close();
    }

    $scope.onSelectDataSetType = function () {
        $scope.viewModel.dataSetDefinition.generatorBeanName = null;
        $scope.viewModel.selectedGeneratorDefinition = null;
        $scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName = null;
        if ($scope.viewModel.dataSetDefinition.type === dataSetType.STATIC) {
            $scope.viewModel.dataSetDefinition.dynamicDefault = null;
        } else {
            $scope.viewModel.dataSetDefinition.dynamicDefault = false;
        }

        loadData().then(function () {
            if ($scope.viewModel.dataSetDefinition.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
                $scope.viewModel.selectedGeneratorDefinition = _.find($scope.viewModel.generatorDefinitionList, function (generatorDefinition) {
                    return generatorDefinition.beanName === 'enhancedDynamicDataSetGenerator';
                });
                $scope.viewModel.dataSetDefinition.generatorBeanName = 'enhancedDynamicDataSetGenerator';
            }
        });
    };

    $scope.onUpdateSelectedGeneratorDefinition = function () {
        $scope.viewModel.dataSetDefinition.generatorBeanName = $scope.viewModel.selectedGeneratorDefinition.beanName;
    };

    $scope.handleMinSearchStringLengthChange = function () {
        const isNegativeNumericValue = _.indexOf($scope.viewModel.dataSetDefinition.minSearchStringLength, '-') !== -1;
        if (isNegativeNumericValue) {
            $scope.viewModel.dataSetDefinition.minSearchStringLength = 1;
        }
        if ($scope.viewModel.dataSetDefinition.minSearchStringLength === '') {
            $scope.viewModel.dataSetDefinition.minSearchStringLength = $scope.viewModel.defaultMinSearchStringLength;
        }
        if(!_.isNumber($scope.viewModel.dataSetDefinition.minSearchStringLength)){
            $scope.viewModel.dataSetDefinition.minSearchStringLength = _.parseInt($scope.viewModel.dataSetDefinition.minSearchStringLength);
        }

    };

    $scope.onConfirm = function () {
        $scope.viewModel.isSubmitDisabled = true;
        if (_.isNil(modalOptions.existingDataSetName)) {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingDataSet'));
            configurationMediator.createDataSet($scope.viewModel.dataSetDefinition).then(saveSuccess, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                $scope.viewModel.isSubmitDisabled = false;
            });
        } else {
            if (modalOptions.existingDataSetName !== $scope.viewModel.dataSetDefinition.name) {
                configurationMediator.getDataSetReferences(modalOptions.existingDataSetName).then(function (result) {
                    if (result.length > 0) {
                        const modalInstance = $uibModal.open({
                            templateUrl: '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html',
                            controller: 'dataSetReferencesController',
                            windowClass: 'dataSetReferencesModal',
                            resolve: {
                                options: function () {
                                    return {
                                        dataSetName: modalOptions.existingDataSetName,
                                        modifyDataSet: true
                                    };
                                }
                            }
                        });
                        modalInstance.result.then(function () {
                            updateDataSet();
                        }, function () {
                            $scope.viewModel.isSubmitDisabled = false;
                        });
                    } else {
                        updateDataSet();
                    }
                });
            } else {
                updateDataSet();
            }
        }
    };

    function updateDataSet() {
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingDataSet'));
        dataSetEditorModel.renameDataSet(modalOptions.existingDataSetName, $scope.viewModel.dataSetDefinition.name);
        if (!$scope.viewModel.dataSetDefinition.supportSearch) {
            $scope.viewModel.dataSetDefinition.minSearchStringLength = $scope.viewModel.defaultMinSearchStringLength;
        }
        configurationMediator.updateDataSet($scope.viewModel.dataSetDefinition, modalOptions.existingDataSetName).then(saveSuccess, function () {
            // on error
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            $scope.viewModel.isSubmitDisabled = false;
        });
    }

    $scope.canEnableConfirmButton = function () {
        const typeIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.type),
            nameIsNotEmpty = !_.isEmpty($scope.viewModel.dataSetDefinition.name),
            dynamicDefaultIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.dynamicDefault),
            supportSearchIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.supportSearch),
            supportSearchFalseOrSupportSearchTrueAndMinSearchStringLengthNotEmpty = !$scope.viewModel.dataSetDefinition.supportSearch || _.isNumber($scope.viewModel.dataSetDefinition.minSearchStringLength),
            generatorBeanNameIsNotEmpty = !_.isEmpty($scope.viewModel.dataSetDefinition.generatorBeanName),
            clearInvalidFieldValueIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.clearInvalidFieldValue),
            repeatingFormTemplateUniqueNameIsNotEmpty = !_.isEmpty($scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName),
            existingDataSet = !_.isNil(modalOptions.existingDataSetName);

        let canEnableConfirmButton = false,
            hasChanged = false;

        if (typeIsNotNil) {
            switch ($scope.viewModel.dataSetDefinition.type) {
                case dataSetType.STATIC:
                    canEnableConfirmButton =
                        typeIsNotNil &&
                        nameIsNotEmpty;
                    break;

                case dataSetType.PRODUCT_FIELD_DEPENDENT:
                case dataSetType.CUSTOM:
                    canEnableConfirmButton =
                        typeIsNotNil &&
                        nameIsNotEmpty &&
                        dynamicDefaultIsNotNil &&
                        supportSearchIsNotNil &&
                        supportSearchFalseOrSupportSearchTrueAndMinSearchStringLengthNotEmpty &&
                        generatorBeanNameIsNotEmpty &&
                        clearInvalidFieldValueIsNotNil;
                    break;

                case dataSetType.REPEATING_FORM:
                    canEnableConfirmButton =
                        typeIsNotNil &&
                        nameIsNotEmpty &&
                        dynamicDefaultIsNotNil &&
                        supportSearchIsNotNil &&
                        supportSearchFalseOrSupportSearchTrueAndMinSearchStringLengthNotEmpty &&
                        generatorBeanNameIsNotEmpty &&
                        clearInvalidFieldValueIsNotNil &&
                        repeatingFormTemplateUniqueNameIsNotEmpty;
                    break;
            }
        }

        if (existingDataSet) {
            hasChanged = !_.isEqual($scope.viewModel.originalDataSetDefinition, $scope.viewModel.dataSetDefinition);
            canEnableConfirmButton = canEnableConfirmButton && hasChanged;
        }

        return canEnableConfirmButton;
    };

    $scope.$on('modal.closing', function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.onCancel = function () {
        $uibModalInstance.close();
    };

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    init();
};

angular.module('ums.configuration')
    .controller('dataSetSettingsController', DataSetSettingsController);
